import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        carrito: {
            productos: [],
            total: 0,
        },
        usuario: null,
        descuento: 0,
        cupon: '',
        numProductos: 0,
        primerVersion: 0,
    },

    getters: {
        productos: state => {
            return state.carrito.productos
        },
        usuario: state => {
            return state.usuario
        },
        total: state => {
            return state.carrito.total
        },
        descuento: state => {
            return state.descuento
        },
        cupon: state => {
            return state.cupon
        },
        numProductos: state => {
            return state.numProductos
        },
        primerVersion: state => {
            return state.primerVersion
        }
    },

    mutations: {
        addProduct(state, producto) {
            const index = state.carrito.productos.findIndex(element => element.id_producto == producto.id_producto)
            if(index == -1)
                state.carrito.productos.push(producto)
            else
                state.carrito.productos[index] = producto
        },

        setUsuario(state, usuario) {
            state.usuario = usuario
        },

        setProductos(state, productos) {
            state.carrito.productos = productos
        },

        setTotal(state, total) {
            state.carrito.total = total
        },

        setDescuento(state, descuento) {
            state.descuento = descuento
        },

        setCupon(state, cupon) {
            state.cupon = cupon
        },

        setNumProductos(state, numProducto) {
            state.numProductos += numProducto
            if(numProducto == 0)
                state.numProductos = 0
        },
        setPrimerVersion(state, primerVersion) {
            state.primerVersion = primerVersion
        },
    }
})

export default store